<template>
        <v-main class="ml-6 mt-3">
        <v-row dense>
            <v-col cols="12">
                <h3>Change Password</h3>
                <p class="mt-8">Select the ARES user who's password needs to be changed <br> A mail will be sent to the 'Villa for You e-mail address' from which the selected user can change his/her password</p>
                <!-- <v-btn @click="extralogin">test</v-btn> -->
                <v-row class="mt-4">
                <v-col cols="4" class="">
                    <select_gebr :selected_gebr="ares_gebr" field="ares_gebr" label="Send password mail to " :isClearable="true" :vfyEmailsOnly="true"  @updateData="updateData" />
                </v-col>      
                <v-col cols="4">
                    <v-btn :disabled="mailSend===true||ares_gebr===''" class="primary mr-4 mt-2" small v-on:click="sendMail"><v-icon medium class="mr-2">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                </v-col>          
                </v-row>
            </v-col>
        </v-row>
        <standard_dialog ref="std_dialog" /> 
        <please_wait ref="wait" :isPersistent="true" display_text="Sending..." :timerInterval="500"/>        
        <navBar title="Ares - Users" :home="true" type="gebr" />
    </v-main>        
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import select_gebr from '@/components/ui/selectors/select_gebr.vue';
    import standard_dialog from '@/components/ui/standard_dialog.vue';
    import please_wait from '@/components/pleaseWait.vue';

    export default {
        components: {
            navBar,
            select_gebr,
            standard_dialog,
            please_wait        
        },
        data() {
            return {
                ares_gebr: '',     
                mailtext: '',
                mailSend: false,
                buttonCaption: 'Send mail',
                buttonIcon: 'mdi-email-fast-outline',                    
            }
        },    
        methods:{
            updateData(data){
                this[data.field] = data.value;
            },	   
            sendMail() {
                this.$axios.post("ares/json/ares/syst/gebr/passwordMail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendMail",
                    },
                    sendMail: {
                        user: this.ares_gebr,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.$refs.std_dialog.open('error', 'Error', res.data.error.message); 
                    } else {
                        this.mailSend=true;
                        this.buttonCaption='Mail sent';
                        this.buttonIcon='mdi-check-circle-outline';
                    }
                })
            },        
        }
    }
</script>

<style scoped>
</style>
